module.exports = __webpack_public_path__ + "img/happybrain_product4.4e746477.jpg";